import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { isArray } from 'lodash';

import { useLoader } from 'Store/loader';
import { useToast } from 'Store/toast';
import upsertScheduleRulesetPayload from './model/request/upsertScheduleRulesetPayload';
import postRuleset from 'Api/schedule-ruleset/postRuleset';

const usePostScheduleRuleset = () => {
  const { t } = useTranslation('schedule-ruleset');
  const queryClient = useQueryClient();
  const { onShowLoader, onResetLoader } = useLoader();
  const { onOpenToast, onResetToast } = useToast();

  return useMutation({
    mutationFn: async (formData) => {
      onShowLoader({ variant: 'loader-primary' });

      const payload = upsertScheduleRulesetPayload(formData);

      return await postRuleset({ payload });
    },
    onSuccess: () => {
      onResetToast();
      queryClient.invalidateQueries({ queryKey: ['ruleset-list'] });

      onOpenToast({
        status: 'success',
        description: t('newRulesetSuccess'),
        duration: 5,
        alwaysShow: false,
      });
    },
    onError: (error) => {
      const errorMessage = isArray(error?.response?.data?.errors) ? error?.response?.data?.errors[0]?.message : t('saveErrorDescription');
      onResetToast();

      onOpenToast({
        status: 'error',
        title: t('errorToastTitle'),
        description: errorMessage,
        duration: 5,
        alwaysShow: false,
      });
    },
    onSettled: () => {
      onResetLoader();
    },
  });
};

export default usePostScheduleRuleset;